module.exports = __webpack_public_path__ + "static/media/ktis.5e971463.jpeg";